//
//
//
//
//
//
//
//
//

export default {
    props: ['resident'],
    data: function data() {
        return {
            propertyName: ''
        };
    },
    created: function created() {
        Event.$on('resident-confirm-portal-invite', this.residentConfirmPortalInvite);
        Event.$on('refresh-resident-dashboard', this.refreshResidentDashboard);
    },
    beforeDestroy: function beforeDestroy() {
        Event.$off('resident-confirm-portal-invite');
        Event.$off('refresh-resident-dashboard');
    },
    mounted: function mounted() {},

    methods: {
        residentConfirmPortalInvite: function residentConfirmPortalInvite() {
            var $el = this;
            $el.$children[0].$data.showSmallModal = true;
        },
        refreshResidentDashboard: function refreshResidentDashboard() {
            var $el = this;
            $el.resident = $el.resident;
            $el.propertyName = $el.resident.property.name;
        },

        sendPortalInvite: function sendPortalInvite() {
            var $el = this;
            var sendData = {
                id: $el.resident.id
            };

            window.axios.post('/prototype/person/resident/portal-invite', sendData).then(function (response) {
                if (response.data === 'no email') {
                    $el.$snotify.error('This resident does not have an associated email address.');
                } else {
                    $el.$snotify.success('Invite sent');
                }
            });
            this.closeModal();
        },
        closeModal: function closeModal() {
            Event.$emit('close-small-modal');
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/person/residents/ResidentConfirmPortalInvite.vue
// module id = jEkX
// module chunks = 0 1